<template>
  <div class="graph-container">
    <header><slot name="title"></slot></header>
    <div class="d-flex justify-content-between align-items-center">
      <div ref="graph" class="graph" :class="{ 'w-100': !showLabels }"></div>
      <div v-if="showLabels" class="w-100 px-4">
        <ul>
          <li v-for="(record, index) in data" :key="index" class="label">
            <slot name="label" v-bind="{ colors, index, othersData, record }">
              <span class="d-flex align-items-center"><span class="label-color mr-2" :style="`background-color: ${colors[index]};`"></span> {{ record[fields.category] }}</span>
              <div class="label-value">{{ record[fields.value] }}</div>
            </slot>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import BaseGraph from "./_BaseGraph";

am4core.useTheme(am4themes_animated);

export default {
  extends: BaseGraph,
  props: {
    showLabels: { type: Boolean, default: true }
  },
  methods: {
    buildGraph () {
      if (this.data) {
        let chart = am4core.create(this.$refs.graph, am4charts.PieChart);

        chart.data = this.data.slice().reverse();

        chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

        chart.data = this.data;

        let series = chart.series.push(new am4charts.PieSeries());
        series.dataFields.value = this.fields.value;
        series.dataFields.category = this.fields.category;

        series.slices.template.inert = true;
        // series.alignLabels = false;

        if (this.showLabels) {
          series.labels.template.disabled = true;
        } else {
          series.labels.template.fontSize = 12
          series.labels.template.text = "[bold]{category}[/]\n[font-size: 10px]{value} · {value.percent.formatNumber('#.0')}%[/]"
          series.labels.template.textAlign = "end"
        }

        series.slices.template.stroke = am4core.color("#fff")
        series.slices.template.strokeWidth = 2
        series.slices.template.strokeOpacity = 1

        series.slices.template.adapter.add("fill", (fill, target) => {
          return this.colors[target.dataItem.index];
        });

        series.hiddenState.properties.startAngle = 90;
        series.hiddenState.properties.endAngle = 90;

        this.chart = chart
      }
    }
  }
};
</script>
<style scoped>
.graph {
  width: 300px;
}
.label {
  display: flex;
  align-items: center;
  font-size: .75rem;
  width: 100%;
}
.label-color {
  display: inline-block;
  height: .75rem;
  width: .75rem;
  border-radius: 3px;
}
.label-value {
  margin-left: auto;
}
</style>
